"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ClassSkillCombo;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SkillModule = _interopRequireDefault(require("../Skill.module.scss"));

var _assets = require("../../../../assets");

var _tooltips = require("../../../tooltips");

var _MouseTooltipContext = _interopRequireDefault(require("../../../tooltips/MouseTooltipContext/MouseTooltipContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ClassSkillCombo(_ref) {
  var skillCombo = _ref.skillCombo,
      viewingCharacter = _ref.viewingCharacter,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useContext = (0, _react.useContext)(_MouseTooltipContext.default),
      setContent = _useContext.setContent,
      show = _useContext.show,
      hide = _useContext.hide;

  var model = skillCombo.model;
  var iconFileName = model.iconFileName,
      isEnabled = model.isEnabled;
  var isLearned = true; // TODO

  var img = "".concat(_assets.ASSETS_SKILLCOMBOS, "/icons/").concat(iconFileName);
  var handleOnMouseEnter = (0, _react.useCallback)(function () {
    hide();
    setContent( /*#__PURE__*/_react.default.createElement(_tooltips.EntityTooltipContent, {
      entity: skillCombo,
      entityType: "classSkillCombo",
      viewingCharacter: viewingCharacter
    }));
    show();
  }, [setContent, show, hide, skillCombo, viewingCharacter]);
  var handleOnMouseLeave = (0, _react.useCallback)(function () {
    hide();
    setContent(undefined);
  }, [setContent, hide]);
  return /*#__PURE__*/_react.default.createElement("div", {
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave,
    className: (0, _classnames.default)(_SkillModule.default.skill, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SkillModule.default.icon,
    style: {
      backgroundImage: "url(".concat(img, ")")
    }
  }), (!isLearned || !isEnabled) && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_SkillModule.default.overlay, " ").concat(_SkillModule.default.deactivated)
  }));
}